
const baseHeaders = {
    'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
    'Content-Security-Policy': "default-src 'self'",
    'X-Frame-Options': 'DENY',
    'X-Content-Type-Options': 'nosniff',
    'Referrer-Policy': 'strict-origin-when-cross-origin',
    'Permissions-Policy': 'camera=(), microphone=(), geolocation=()',
};

const getRequest = (url) => {
    return handleResponse(
        fetch(url, {
            method: 'GET',
            headers: {
                ...baseHeaders,
                'Content-Type': 'application/json',
                'ozt': localStorage.getItem(process.env.REACT_APP_LS_TOKEN)

            },
        })
    );
}

const postRequest = (url, data) => {
    return handleResponse(
        fetch(url, {
            method: 'POST',
            headers: {
                ...baseHeaders,
                'Content-Type': 'application/json',
                'ozt': localStorage.getItem(process.env.REACT_APP_LS_TOKEN)

            },
            body: JSON.stringify(data)
        })
    );
}

const postRequestText = (url, data) => {
    return handleResponse(
        fetch(url, {
            method: 'POST',
            headers: {
                ...baseHeaders,
                'Content-Type': 'text/plain',
                'ozt': localStorage.getItem(process.env.REACT_APP_LS_TOKEN)

            },
            body: data
        })
    );
}

const postFormRequest = (url, data) => {
    return handleResponse(
        fetch(url, {
            method: 'POST',
            headers: {
                // FormData için 'Content-Type' tarayıcı tarafından otomatik ayarlanmalıdır.
                // Bu yüzden sadece baseHeaders'ı 'Content-Type' olmadan ekliyoruz.
                ...baseHeaders,
                'ozt': localStorage.getItem(process.env.REACT_APP_LS_TOKEN)

            },
            body: data
        })
    );
}

const putRequest = (url, data) => {
    return handleResponse(
        fetch(url, {
            method: 'PUT',
            headers: {
                ...baseHeaders,
                'Content-Type': 'application/json',
                'ozt': localStorage.getItem(process.env.REACT_APP_LS_TOKEN)

            },
            body: JSON.stringify(data)
        })
    );
}

const deleteRequest = (url, data) => {
    return handleResponse(
        fetch(url, {
            method: 'DELETE',
            headers: {
                ...baseHeaders,
                'Content-Type': 'application/json',
                'ozt': localStorage.getItem(process.env.REACT_APP_LS_TOKEN)

            },
            body: JSON.stringify(data)
        })
    );
}

const handleResponse = (promise) => {
    return promise.then(response => {
        if (!response.ok) {
            if (response.status === 401) {
                // Yetkisiz istek durumunda kullanıcıyı giriş sayfasına yönlendir.
                window.location.href = process.env.PUBLIC_URL;
                return { success: false };
            }
            return Promise.reject(response.statusText);
        }
        // text/plain gibi farklı response türlerini de handle etmek gerekebilir.
        // Şimdilik sadece json varsayılıyor.
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            return response.json();
        } else {
            return response.text();
        }
    });
}

const getFileRequest = (url, method, data) => {
    return fetch(url, {
        method: method,
        headers: {
            ...baseHeaders,
            'Content-Type': 'application/octet-stream',
            'ozt': localStorage.getItem(process.env.REACT_APP_LS_TOKEN)

        },
        body: JSON.stringify(data)
    });
}

const getFileRequestData = (url, method, data) => {
    return fetch(url, {
        method: method,
        headers: {
            ...baseHeaders,
            'Content-Type': 'application/json',
            'ozt': localStorage.getItem(process.env.REACT_APP_LS_TOKEN)

        },
        body: JSON.stringify(data)
    });
}

export const requestTool = {
    getRequest,
    postRequest,
    putRequest,
    deleteRequest,
    postFormRequest,
    postRequestText,
    getFileRequest,
    getFileRequestData
}

export default requestTool;